import axios from 'axios';
import { useCallback } from 'react';
import { useDispatch, useSelector, shallowEqual } from 'react-redux';
import { EXPORT_API_REQUEST_URL } from '../../../common/apiConfig';
import {
  REPORTS_EXPORT_SUMMARY_REPORT_BEGIN,
  REPORTS_EXPORT_SUMMARY_REPORT_SUCCESS,
  REPORTS_EXPORT_SUMMARY_REPORT_FAILURE,
  REPORTS_EXPORT_SUMMARY_REPORT_DISMISS_ERROR,
} from './constants';

export function exportSummaryReport(args = {}) {
  return (dispatch) => { // optionally you can have getState as the second argument
    dispatch({
      type: REPORTS_EXPORT_SUMMARY_REPORT_BEGIN,
    });

    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.post(`${EXPORT_API_REQUEST_URL}/exportSalesSummary`, args);
      doRequest.then(
        (res) => {
          dispatch({
            type: REPORTS_EXPORT_SUMMARY_REPORT_SUCCESS,
            data: res.data.data,
          });
          resolve(res.data.data);
        },
        // Use rejectHandler as the second argument so that render errors won't be caught.
        (err) => {
          const errorMsg = err && err.response ? err.response.data.message : 'There is an error. Please refresh page or contact administrator.';
          dispatch({
            type: REPORTS_EXPORT_SUMMARY_REPORT_FAILURE,
            data: { error: errorMsg },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissExportSummaryReportError() {
  return {
    type: REPORTS_EXPORT_SUMMARY_REPORT_DISMISS_ERROR,
  };
}

export function useExportSummaryReport() {
  const dispatch = useDispatch();

  const { exportSummaryReportPending, exportSummaryReportError } = useSelector(
    state => ({
      exportSummaryReportPending: state.reports.exportSummaryReportPending,
      exportSummaryReportError: state.reports.exportSummaryReportError,
    }),
    shallowEqual,
  );

  const boundAction = useCallback((...args) => {
    return dispatch(exportSummaryReport(...args));
  }, [dispatch]);

  const boundDismissError = useCallback(() => {
    return dispatch(dismissExportSummaryReportError());
  }, [dispatch]);

  return {
    exportSummaryReport: boundAction,
    exportSummaryReportPending,
    exportSummaryReportError,
    dismissExportSummaryReportError: boundDismissError,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case REPORTS_EXPORT_SUMMARY_REPORT_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        exportSummaryReportPending: true,
        exportSummaryReportError: null,
      };

    case REPORTS_EXPORT_SUMMARY_REPORT_SUCCESS:
      // The request is success
      return {
        ...state,
        exportSummaryReportPending: false,
        exportSummaryReportError: null,
      };

    case REPORTS_EXPORT_SUMMARY_REPORT_FAILURE:
      // The request is failed
      return {
        ...state,
        exportSummaryReportPending: false,
        exportSummaryReportError: action.data.error,
      };

    case REPORTS_EXPORT_SUMMARY_REPORT_DISMISS_ERROR:
      // Dismiss the request failure error
      return {
        ...state,
        exportSummaryReportError: null,
      };

    default:
      return state;
  }
}
